import { KanbanSwimlaneCriteria } from '../../enums';

export type SwimlaneCriteriaMap<T, K = T> = {
    [KanbanSwimlaneCriteria.ETA]: T;
    [KanbanSwimlaneCriteria.NORMAL_DURATION]: K;
};

type AssertExhaustive<T extends never> = T;

// checks that are KanbanSwimlaneCriteria keys are presen in SwimlaneCriteriaMap
// eslint-disable-next-line @typescript-eslint/no-unused-vars
type _Check = AssertExhaustive<Exclude<KanbanSwimlaneCriteria, keyof SwimlaneCriteriaMap<never>>>;
